import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-inside-experience-cabin.jpg`;
const ALT = "Intimate 1:1 coaching conversation by the fireplace in a warm cabin setting.";

export function InsideExperience() {
  return (
    <section data-testid="inside-experience-section" className="relative overflow-hidden bg-[#EFF5F4]">
      {/* Headline */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[39px] md:pt-[50px] pb-8 md:pb-10 reveal">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917]">
            Inside the Experience
          </h2>
        </div>
      </div>

      {/* Full-bleed band: image on the right dissolving into the page; text on the clean left */}
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band — edge-only mask feather (no overlay) */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[54%]">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            objectPosition="50% 40%"
            featherLeft={46}
            featherTop={12}
            featherBottom={12}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top — bottom edge feathers into the page */}
        <div className="lg:hidden relative w-full aspect-[4/3] mb-8">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            objectPosition="50% 40%"
            featherBottom={18}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 flex items-center lg:min-h-[min(66vh,560px)]">
          <div className="w-full lg:w-1/2">
            <div className="space-y-5 max-w-[515px]">
              <p className="text-xl text-[#57534E] leading-relaxed">
                Every experience begins with you and ends with you.
              </p>
              <p className="text-xl text-[#57534E] leading-relaxed">
                A personal blueprint rooted in your values.
              </p>
              <p className="font-display text-3xl md:text-4xl text-[#159E9A] leading-snug">
                Honest conversations.
              </p>
              <p className="text-xl text-[#57534E] leading-relaxed">
                Tactical exercises that move you from stuck to clear.
              </p>
              <p className="font-display text-2xl md:text-3xl text-[#1C1917] leading-snug pt-2">
                And a plan that&rsquo;s actually yours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
